import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { useState } from "react";

import { WithContexts } from "./components/AppContext";
import { AppTabs } from "./components/AppTabs";
import { createServices, ServiceContext } from "./services";

const queryClient = new QueryClient({
  defaultOptions: {
    queries: {
      refetchOnWindowFocus: false, // default: true
    },
  },
});

export function App() {
  const [services] = useState(() => createServices());

  return (
    <QueryClientProvider client={queryClient}>
      <div className="app">
        <ServiceContext.Provider value={services}>
          <WithContexts>
            <AppTabs />
          </WithContexts>
        </ServiceContext.Provider>
      </div>
    </QueryClientProvider>
  );
}
